export default "__VITE_ASSET__Y1zMiY0wPdKzmdmhicIokg__"